import { StateMetadata, CountyOption } from 'interfaces/StateMetadata';

export interface StateSupportInfo {
  level: 'county' | 'state' | 'none';
  countyCount: number;
  displayText: string;
  color: string;
  isClickable: boolean;
  hasCounties: boolean;
  hasStateSupport: boolean;
}

export const getStateSupportInfo = (
  stateMetadata: StateMetadata,
  counties: CountyOption[],
): StateSupportInfo => {
  // Use the canonical state name directly from the stateMetadata
  const canonicalStateName = stateMetadata.state;
  const stateCounties = counties.filter((county) =>
    county.county_state.endsWith(`, ${canonicalStateName}`),
  );

  const countyCount = stateCounties.length;
  const hasCounties = countyCount > 0;
  const hasStateSupport = !!stateMetadata.url;
  const isClickable = hasCounties || hasStateSupport;

  let level: 'county' | 'state' | 'none';
  let displayText: string;
  let color: string;

  // Use link_counties as source of truth
  if (stateMetadata.link_counties) {
    // County-only support
    level = 'county';
    displayText = `${countyCount} ${countyCount === 1 ? 'county' : 'counties'}`;
    color = '#267e4b';
  } else if (hasStateSupport) {
    // State-wide support (when link_counties is false)
    level = 'state';
    displayText = 'State-wide';
    color = '#75bc93';
  } else {
    // No support
    level = 'none';
    displayText = 'Not available';
    color = '#bdbdbd';
  }

  return {
    level,
    countyCount,
    displayText,
    color,
    isClickable,
    hasCounties,
    hasStateSupport,
  };
};
